"use strict";

require("core-js/modules/es6.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArgumentOutOfRangeErrorImpl = function () {
  function ArgumentOutOfRangeErrorImpl() {
    Error.call(this);
    this.message = 'argument out of range';
    this.name = 'ArgumentOutOfRangeError';
    return this;
  }

  ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
  return ArgumentOutOfRangeErrorImpl;
}();

exports.ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;